"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useGlobalStyles = (0, styles_1.makeStyles)(function () { return (0, styles_1.createStyles)({
    '@global': {
        html: {
            boxSizing: 'border-box'
        },
        body: {
            margin: 0,
        },
        '*': {
            boxSizing: 'inherit',
            '&:focus': {
                outline: 'none'
            },
            '&:active': {
                outline: 'none'
            },
            '&:before': {
                boxSizing: 'inherit'
            },
            '&:after': {
                boxSizing: 'inherit'
            }
        },
        a: {
            textDecoration: 'none',
            transition: 'opacity .15s linear',
            '&:hover': {
                opacity: '.75',
                textDecoration: 'none'
            }
        }
    }
}); });
exports.default = useGlobalStyles;
